











































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { AuctionListings } from '@/AuctionListings'
import { AuctionListing, sortOrderTypes, filterTypes } from '@/AuctionListing'
import * as utils from '@/utils';
import * as utils_topshot from '@/utils_topshot';
import AuctionListingListComponent from '@/components/AuctionListingListComponent.vue';                               // @ is an alias to /src
import MomentSelectorAndSorterComponent from '@/components/MomentSelectorAndSorterComponent.vue';                       // @ is an alias to /src
import { IPaginationResult } from '@/PaginationResult'
import { Challenge } from '@/Challenge'
import { TokenUser } from '@/TokenUser'
import ModalWrapperComponent from '@/components/ModalWrapperComponent.vue';             // @ is an alias to /src
import { io, Socket } from "socket.io-client";

@Component({
  name: 'AuctionListingsComponent',
  components: { AuctionListingListComponent, MomentSelectorAndSorterComponent, ModalWrapperComponent }
})
export default class AuctionListingsComponent extends Vue {
  // prop reactive member variables publically available to the html template
  @Prop({ default: null })
  public startingPlayerID: number
  @Prop()
  public startingSetID: number
  @Prop()
  public startingPlayID: number

  // public reactive member variables available to the html template
  public lastFetchedURL: string = null;
  public moments: AuctionListing[] = []
  public auctionListings: AuctionListings = null
  public paginationResult: IPaginationResult = null
  public sortOrder: sortOrderTypes = this.getSortOrders()[0].sort
  public noSelector: boolean = false
  public auctionId: string = null

  public filter: filterTypes = filterTypes.Live
  public filterOptions: Array<{ text: string, value: filterTypes, disabled: boolean }> = [
    { text: 'Live Now', value: filterTypes.Live, disabled: false },
    { text: 'Sold Recently', value: filterTypes.Sold, disabled: false },
    // { text: 'Unsold', value: filterTypes.Unsold, disabled: false },
  ]


  public async onSearch() {
    this.pageNumberToLoadNext = 1
    await this.fetchData(false, this.pageNumberToLoadNext)
  }

  // public functions available to the html template
  public get loading(): boolean { return this.$store.state.loading }
  public get user(): TokenUser { return this.$store.getters.userObject }
  public get userId(): string { return this.$store.getters.userId }

  // events from MomentSelectorAndSorterComponent
  public async onChangedSort(sortOrder: { label: string, sort: sortOrderTypes }) {
    this.sortOrder = sortOrder.sort
    this.pageNumberToLoadNext = 1
    await this.fetchData(false, this.pageNumberToLoadNext)
  }
  public async onChangedPSD(player: { label: string, playerID: number }, set: { label: string, setID: number }, duo: { label: string, setID: number, playID: number }) {
    this.playerID = player.playerID
    this.setID = duo.setID || set.setID
    this.playID = duo.playID

    this.pageNumberToLoadNext = 1
    await this.fetchData(false, this.pageNumberToLoadNext)
  }

  @Watch('filter')
  public async onChangedFilter() {
    // smart sort based on filter chosen
    if (this.filter === filterTypes.Live) this.sortOrder = 'EndDate_ASC';     // ending soonest
    else this.sortOrder = 'EndDate_DESC';

    (this.$refs.MomentSelectorAndSorterComponent as MomentSelectorAndSorterComponent).notifyChangedSortFromParent(this.sortOrder)

    this.pageNumberToLoadNext = 1
    this.moments = []
    this.paginationResult = null
    await this.fetchData(false, this.pageNumberToLoadNext)
  }

  public async infiniteHandler(state: any): Promise<void> {
    const numReturned: number = await this.fetchData(true, this.pageNumberToLoadNext)
    if (numReturned === 0) {
      if (this.$store.state.devmode) console.log(`infiniteHandler(): state.complete after getting 0 items`)
      state.complete()
    } else {
      state.loaded();
    }
  }

  public getSortOrders(): Array<{ label: string, sort: sortOrderTypes }> {
    return [
      { label: 'Sort by Ending Soonest', sort: 'EndDate_ASC' },
      { label: 'Sort by Newest', sort: 'ListedDate_DESC' },
      { label: 'Sort by Lowest Price', sort: 'CurrentPrice_ASC' },
      { label: 'Sort by Highest Price', sort: 'CurrentPrice_DESC' },
      { label: 'Sort by Serial', sort: 'Serial_ASC' },
      { label: 'Sort by Recently Ended', sort: 'EndDate_DESC' },
    ]
  }

  public isValidSortOrder(sort: sortOrderTypes): boolean {
    for (const so of this.getSortOrders()) if (so.sort === sort) return true
    return false
  }

  // parallel to this, allow auto popup of a specific auction
  public onViewAuction(moment: AuctionListing) {
    this.auctionId = moment.auction.getIdAsString()
    const dynamicProps: any = { auctionId: this.auctionId, temporaryURL: moment.auction.getLiveTokenAuctionLink() };
    (this.$refs.AuctionComponent as ModalWrapperComponent).show('Loading auction details...', 'md', dynamicProps);
  }

  public onAuctionChangedModalShow(componentName: string, showing: boolean, payload: any) {
    if (!showing) {
      this.auctionId = null
      this.addParamsToURL()        // to remove auctionId from URL
    }
  }

  // private, non-reactive member variables
  private lastFetchSucceeded: boolean;
  private pageNumberToLoadNext: number = 1
  private playerID: number = null
  private setID: number = null
  private playID: number = null
  private socket: Socket = null
  private numConnectionErrors: number = 0
  private isConnectedBySocket: boolean

  // private functions not available directly to HTML template
  private async mounted() {
    if (this.$store.state.devmode) console.log(`${this.$options.name} mounted()`);

    // console.log(this.$route.query.auctionId)

    // if auctionId is passed as a query string parameter, fetch that one and popup up AuctionComponent
    if (this.$route.query.auctionId) {
      this.auctionId = this.$route.query.auctionId as string
      const dynamicProps: any = { auctionId: this.auctionId };
      (this.$refs.AuctionComponent as ModalWrapperComponent).show('Loading auction details...', 'md', dynamicProps);
      // console.log(`Popping up auction ${this.auctionId}`)
    }

    // props
    this.playerID = this.startingPlayerID
    this.setID = this.startingSetID || null
    this.playID = this.startingPlayID || null

    // use params from URL if they exists
    if (this.$route.query.noSelector) this.noSelector = true;
    if (this.$route.query.playerID) this.playerID = Number(this.$route.query.playerID);
    if (this.$route.query.setID) this.setID = Number(this.$route.query.setID);
    if (this.$route.query.playID) this.playID = Number(this.$route.query.playID);
    if (this.$route.query.sortOrder) {
      this.sortOrder = this.$route.query.sortOrder as sortOrderTypes;
      if (this.isValidSortOrder(this.sortOrder))
        (this.$refs.MomentSelectorAndSorterComponent as MomentSelectorAndSorterComponent).notifyChangedSortFromParent(this.sortOrder)
      else
        this.sortOrder = this.getSortOrders()[0].sort
    } else {
      this.sortOrder = this.getSortOrders()[0].sort
    }

    const promises: Array<Promise<any>> = []

    if (this.playerID) promises.push((this.$refs.MomentSelectorAndSorterComponent as MomentSelectorAndSorterComponent).notifyChangedPlayerIDFromParent(this.playerID))
    if (this.setID && !this.playID) promises.push((this.$refs.MomentSelectorAndSorterComponent as MomentSelectorAndSorterComponent).notifyChangedSetIDFromParent(this.setID))
    if (this.playerID && this.setID && this.playID) promises.push((this.$refs.MomentSelectorAndSorterComponent as MomentSelectorAndSorterComponent).notifyChangedPlayerIDAndSetIDAndPlayIDFromParent(this.playerID, this.setID, this.playID))

    promises.push(this.fetchData(false, this.pageNumberToLoadNext))

    await Promise.all(promises)

  }
  private async beforeDestroy() { 
    if (this.$store.state.devmode) console.log(`${this.$options.name} beforeDestroy()`)

    if (this.socket && this.isConnectedBySocket) {
      this.socket.emit('leaveRoom', `allAuctionEvents`, this.user && this.user._temp.account ? this.user._temp.account.username : null, this.userId ? this.userId : null )
      this.socket.disconnect()
    }

    this.socket = null
  }

  // add flowAddresses as query params to current url path
  private addParamsToURL() {
    // console.log(`addParamsToURL() got auctionId: ${this.auctionId}`)
    let extra: string = ''
    if (this.playerID) extra += `&playerID=${encodeURIComponent(this.playerID)}`
    if (this.setID) extra += `&setID=${encodeURIComponent(this.setID)}`
    if (this.playID) extra += `&playID=${encodeURIComponent(this.playID)}`
    if (this.sortOrder && this.sortOrder !== this.getSortOrders()[0].sort) extra += `&sortOrder=${encodeURIComponent(this.sortOrder)}`
    if (this.auctionId) extra += `&auctionId=${encodeURIComponent(this.auctionId)}`
    extra = extra.replace('&', '?')
    this.$router.replace(`${this.$route.path}${extra}`).catch(() => {})
    if (this.$store.state.devmode) console.log(`Replacing url with ${this.$route.path}${extra}`)
  }

  // the reason for pageNumberWhenCalled is for race-condition prevention
  private async fetchData(calledByInfiniteHandlerOrTimer: boolean, pageNumberWhenCalled: number): Promise<number> {
    this.addParamsToURL()

    const header: AuctionListing = new AuctionListing(null)
    header.momentID = 0
    header.valueFMV = 0

    let url: string = utils.getURLprefix() + `/api/topshot/auctionListings/`;
    url += `?page=${pageNumberWhenCalled}`;
    url += `&sortOrder=${this.sortOrder}`;
    if (this.playerID) url += `&playerID=${this.playerID}`
    if (this.setID) url += `&setID=${this.setID}`
    if (this.playID) url += `&playID=${this.playID}`
    if (!utils_topshot.getChallenges()) url += `&sc=true`
    url += `&filter=${this.filter}`;

    // don't fetch if we're in the middle of fetching same url
    if (this.loading) {
      if (this.lastFetchedURL === url || calledByInfiniteHandlerOrTimer) {
        if (this.$store.state.devmode) console.log(`AuctionListingsComponent.fetchData() aborting calledByInfiniteHandler and we're already loading`)
        await utils.sleep(1000)     // wait 1 s so we don't go into 100% CPU infinite loop
        return
      }
    }

    this.$store.commit('setLoading', { loading: true });
    this.lastFetchedURL = url;
    try {
      // console.log(url)
      this.lastFetchSucceeded = false;
      const response: any = await utils.makeGetCall(url);

      // whoa, we got another call after this one, so let's abort this one cuz the latest one should take precedent
      if (this.lastFetchedURL !== url) return

      // in case old version
      if (utils.isClientOld()) {
        if (this.$store.state.devmode) console.log("Calling this.$router.go(0)");
        this.$router.go(0);
        this.$store.commit('setLoading', { loading: false });
        return;
      }

      // error check
      if (response.data.error) {
        utils.toast(this, 'Error', response.data.error)
        this.$store.commit('setLoading', { loading: false });
        return
      }

      // challenges
      if (response.data.challenges) utils_topshot.setChallenges(response.data.challenges.map((po) => new Challenge(po)))
      if (response.data.expiredChallenges) utils_topshot.setExpiredChallenges(response.data.expiredChallenges.map((po) => new Challenge(po)))

      // load up the MPListings
      if (response.data.auctionListings) {
        this.auctionListings = new AuctionListings(response.data.auctionListings)

        // pagination result
        this.paginationResult = response.data.paginationResult

        // load up the moments separately from the MPListings object in case we want to do paging (might do everything inside MPListings eventually)
        let newRawItems: AuctionListing[] = response.data.auctionListings.moments
        if (newRawItems) {
          newRawItems = newRawItems.map((po) => new AuctionListing(po));
          if (pageNumberWhenCalled === 1) {
            this.moments = [ header ].concat(newRawItems);
          } else {
            // normally i would just concat the newRawItems, but beacuse socket.io stuff may have added it already, let's check first
            for (const newMoment of newRawItems) {
              const existingMoment: AuctionListing = this.findAuctionListing(newMoment.momentID)
              if (!existingMoment) this.moments.push(newMoment)
            }
          }

          this.connectSocket()

          this.pageNumberToLoadNext++
          this.lastFetchSucceeded = true

          this.addParamsToURL()     // shouldn't have to do this again but for some reason I do

          return newRawItems.length
        } else {
          this.lastFetchSucceeded = false;
          return 0
        }
      } else {
        this.auctionListings = null
        this.paginationResult = null
        this.moments = []
      }

    } catch (error) {
      if (error.toString().includes('Network Error') || error.toString().includes('status code 502')) utils.toast(this, 'Error', 'Undergoing Maintenance'); else utils.toast(this, 'Error', 'Could not load url')
      if (this.$store.state.devmode) console.log(error);
      return 0
    } finally {
      this.$store.commit("setLoading", { loading: false });
    }

    if (this.$store.state.devmode) utils.toast(this, 'DEBUGGING', `Loaded ${this.moments.length} moments`)
  }

  private findAuctionListing(momentID: number): AuctionListing {
    for (const moment of this.moments) if (moment.momentID === momentID) return moment
  }

  private sortMoments() {
    const headerMoment: AuctionListing = this.moments[0]
    const newMomentsList: AuctionListing[] = this.moments.slice(1)

    switch (this.sortOrder) {
      case 'CurrentPrice_ASC': newMomentsList.sort((m1, m2) => (m1.auction.currentPrice - m2.auction.currentPrice)); break;
      case 'Serial_ASC': newMomentsList.sort((m1, m2) => (m1.serialNumber - m2.serialNumber)); break;
      case 'ListedDate_DESC': newMomentsList.sort((m1, m2) => ((m2.auction.startDate ? m2.auction.startDate.getTime() : 0) - (m1.auction.startDate ? m1.auction.startDate.getTime() : 0))); break;
      case 'EndDate_ASC': newMomentsList.sort((m1, m2) => ((m1.auction.endDate ? m1.auction.endDate.getTime() : 0) - (m2.auction.endDate ? m2.auction.endDate.getTime() : 0))); break;
    }

    newMomentsList.unshift(headerMoment)
    this.moments = newMomentsList
  }

  // https://socket.io/docs/v4/client-socket-instance/
  private connectSocket() {
    if (this.socket && this.isConnectedBySocket) return
    try {
      // https://socket.io/docs/v3/using-multiple-nodes/
      this.socket = io(utils.getURLprefix(), { autoConnect: true, transports: [ "websocket" ] });   // it was very important to not allow polling 

      // for debugging
      if (this.$store.state.devmode) {
        this.socket.onAny((event, ...args) => {
          console.log(event, args);
        });
      }

      // handle an new AuctionListing being sent in from server
      this.socket.on("newAuctionListing", (po: object) => {
        if (this.filter === filterTypes.Live) {
          const newMoment: AuctionListing = new AuctionListing(po)
          this.moments.push(newMoment)

          // re sort since we just added a new one
          this.sortMoments()
        }
      });

      // handle an updated AuctionListing being sent in from server (but sans usersHighestBid, so let's preserve the one we had)
      this.socket.on("updatedAuctionListing", (po: object) => {
        const updatedMoment: AuctionListing = new AuctionListing(po)
        const existingMoment: AuctionListing = this.findAuctionListing(updatedMoment.momentID)
        if (existingMoment) {
          const usersHighestBid: number = existingMoment.usersHighestBid
          Object.assign(existingMoment, updatedMoment)
          existingMoment.usersHighestBid = usersHighestBid
          if (this.$store.state.devmode) console.log(`Got updated auctionListing moment for ${updatedMoment.auction.getIdAsString()}`);
        } else {
          if (this.$store.state.devmode) console.log(`Got updated auctionListing moment for ${updatedMoment.auction.getIdAsString()} but ignored cuz not in list`);
        }

        // re sort since endtime and prices may have changed
        this.sortMoments()
      });

      // This event is fired by the Socket instance upon connection and reconnection
      this.socket.on("connect", async () => {
        if (this.$store.state.devmode) console.log(`${new Date().toLocaleString()}: Socket ${this.socket.id} connected`)
        if (this.socket) {
          this.isConnectedBySocket = true
          this.socket.emit('joinRoom', `allAuctionEvents`, this.user && this.user._temp.account ? this.user._temp.account.username : null, this.userId ? this.userId : null )
        }
      });
      this.socket.on("connect_error", async () => {
        this.numConnectionErrors++
        if (this.$store.state.devmode) console.log(`${new Date().toLocaleString()}: Socket ${this.socket.id} got connect_error. Waiting ${this.numConnectionErrors}s before attempting reconnect`)
        await utils.sleep(this.numConnectionErrors * 1000)
        this.isConnectedBySocket = false
        if (this.socket) this.socket.connect();
      });
      this.socket.on("disconnect", (reason: string) => {
        this.isConnectedBySocket = false

        // not sure why every so often we get - "Socket undefined disconnected with reason: transport close"
        if (this.$store.state.devmode) console.log(`${new Date().toLocaleString()}: Socket ${this.socket.id} disconnected with reason: ${reason}`)

        if (reason === "io server disconnect") {
          // the disconnection was initiated by the server, so you need to reconnect manually (other forms of disconnect will auto reconnect)
          // if (this.$store.state.devmode || utils_topshot.getBubbaMode()) console.log(`${new Date().toLocaleString()}: Atempting manual reconnect because reason was ${reason}`)
          if (this.socket) this.socket.connect();
        }

      });

    } catch (e) {

    }

  }
}
